module.exports = __webpack_public_path__ + "img/symbol_4.bee79272.png";